import React   , {useEffect, useState } from "react";
import {useSelector, useDispatch} from "react-redux";
import TaskInformation from "../TaskInformation";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import ValidationButton from "../ValidationButton";
import PreviewButton from "../PreviewButton";
import { getTask, unclaimTask, claimTask , completeTask } from "../../../store/action/taskAction";
import {useNavigate, useParams} from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        position: 'relative'
    },
    paper: {
        display: "flex",
        borderRadius: "11px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    },
    leftSection: {
        flex: 1,
        padding: "40px",
    },
    rightSection: {
        flex: 1,
        padding: "20px",
    },
    inputLabel:{
        color: 'rgba(70, 78, 95, 1)',
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12
    },
    inputTextArea: {
        width: "100%",
        marginBottom: "20px",

    },
    inputContainer: {
        border: 'rgba(243, 246, 249, 1)',
        background: 'rgba(243, 246, 249, 1)',
        width: "100%",
        height: '36px',
        borderRadius: 4,
        marginBottom: "20px",
    },

    //for the preview btn
    previewBtn:{
        position: 'absolute',
        //background: 'rgb(243, 246, 249)',
        right: '30px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    },
    optionText:{
        padding: "5px",
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12
    },
    selectInputDialog: {
        width: "100%",
        border: "0",
        padding: "5px",
        background: "rgba(243, 246, 249, 1)",
        height: "36px",
        borderRadius: 5,
    },
    optionItem: {
        width: "100%",
        padding: theme.spacing(1),
        cursor: "pointer",
        backgroundColor: "white",
        color: "rgba(32, 18, 70, 1)",
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        textAlign: "left",
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
        "&.Mui-selected": {
            backgroundColor: "rgba(240, 243, 199, 1)",
            color: "rgba(60, 101, 86, 1)",
            "&:hover": {
                backgroundColor: "rgba(240, 243, 199, 0.8)",
            },
        },
    },
    autocompleteTag: {
        fontFamily: 'Poppins, sans-serif',
        backgroundColor: 'rgba(240, 243, 199, 1)',
        color: 'rgba(60, 101, 86, 1)',
        border: 'none',
        fontSize: '0.75rem',
        padding: '2px 6px',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '2px',
        borderRadius: '16px',
        display: 'inline-block',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    tooltip: {
        fontSize: '0.75rem',
        maxWidth: '300px',
        whiteSpace: 'pre-wrap',
    },
}));

const MakeIneligible = () => {
    const { taskId } = useParams();
    const navigate = useNavigate();
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const [ decision , setDecision]= useState(true);
    const [ motif , setMotif]= useState("");
    const [ subMotifs , setSubMotifs]= useState([]); 
    const [ comment , setComment]= useState("");
    const username = localStorage.getItem('username');
    const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    const [variables, setVariables] = useState(task?.variables)
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)
    const repartionMissionId = task?.variables?.repartionMissionId?.value;
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);

    const motifs = [
        { value: "MANQUE_PIECE", label: "Manque pièce" },
        { value: "PIECE_ERRONEE", label: "Pièce erronée" },
        { value: "AVIS_EXPERT_DEFAVORABLE", label: "Avis expert défavorable" }
    ];

    const subMotifsOptions = {
        MANQUE_PIECE: [
            { value: "FACTURE", label: "Facture" },
            { value: "ATTESTATION_NON_PV", label: "Attestation de non pv" },
            { value: "PV_ENQUETE", label: "Pv d'enquétte" },
            { value: "CERTIFICAT_RETRAIT", label: "Certificat de retrait" },
            { value: "COPIE_CARTE_GRISE", label: "Copie carte grise" },
            { value: "LETTRE_LEASING", label: "Lettre leasing" },
            { value: "ATTESTATION_PROTECTION_CIVILE", label: "Attestation de protection civile" },
            { value: "ATTESTATION_ASSURANCE_TIERS", label: "Attestation d'assurance de tiers" },
            { value: "DOCUMENTS_VOL_TOTAL", label: "Documents vol total" },
            { value: "DEUXIEME_CONSTAT", label: "2eme constat" },
            { value: "PHOTO_VH_TIERS", label: "Photo de vh tiers" },
            { value: "PHOTO_MANQUANTE", label: "Photo manquante" },
            { value: "JUSTIFICATIF_METEO", label: "Justificatif météo" }
        ],
        PIECE_ERRONEE: [
            { value: "FACTURE_ERRONEE", label: "Facture (anti datée -bon de livraison -devis)" },
            { value: "PHOTO_ERRONEE", label: "Photo erronée" },
            { value: "RECTIFICATION_RAPPORT", label: "Rectification rapport (Valeur à neuf-valeur vénale -valeur epave-detail tiers -origine incendie -manque avis -motif avis defavorable)" }
        ],
        AVIS_EXPERT_DEFAVORABLE: [
            { value: "AVIS_DEFAVORABLE", label: "Avis expert défavorable" }
        ]
    };

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

    const fetchTask = async () => {
        try {
            const response = await getTask(taskId, username); 
            setTask(response);
            setInfoSinistre(task?.businessKey)
            setVariables(task?.variables)
            if(response.assignee === username){
                 
                setIsTaskClaimed(false)
            }else { 
                setIsTaskClaimed(true)
            }
             
        } catch (error) {
            console.error(`Error fetching task details: ${error.message}`);
        }
    };

    const handleDecisionChange = (e) => {
        const value = e.target.value === "true";
        setDecision(value);
        if (value === true) {
            setMotif("");
            setSubMotifs([]);
        }
    };

    const handleMotifChange = (e) => {
        setMotif(e.target.value);
        setSubMotifs([]); // Reset sub-motifs when motif changes
    };

    const handleSubMotifsChange = (event, newValue) => {
        // If the clicked option is already selected, remove it
        const clickedOption = event.target.textContent;
        const isAlreadySelected = subMotifs.some(option => option.label === clickedOption);
        
        if (isAlreadySelected) {
            setSubMotifs(subMotifs.filter(option => option.label !== clickedOption));
        } else {
            setSubMotifs(newValue);
        }
    };

    const ValidationAction = async () => {
        const validationErrors = [];

        if (decision === null || decision === undefined) {
            validationErrors.push("Veuillez sélectionner une décision d'éligibilité");
        }

        if (decision === false) {
            if (!motif) {
                validationErrors.push("Un motif est requis pour une non-éligibilité");
            }
            if (motif !== "AVIS_EXPERT_DEFAVORABLE" && subMotifs.length === 0) {
                validationErrors.push("Au moins un sous-motif est requis pour une non-éligibilité");
            }
        }

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }
        try {
            const updatedVariables = {
                ...variables,
                eligibilityForPayment: {
                    "value": decision,   nonEligiblityMotif: {
                        "value": motif.label,
                        "type": "String"
                    },
                    "type": "Boolean"
                },
                ...(decision === false && {
                    nonEligiblityMotif: {
                        "value": motif,
                        "type": "String"
                    },
                    nonEligiblitySubMotifs: {
                        "value": subMotifs.map(subMotif => subMotif.label).join(','),
                        "type": "String"
                    },
                    nonEligiblityComment: {
                        "value": comment,
                        "type": "String"
                    }
                })
            };
            
            setVariables(updatedVariables);
            console.log('Updated variables:', updatedVariables);

            await dispatch(completeTask(taskId, username, updatedVariables));
            navigate('/SettlementEligibleClaim', { reload: true });
        } catch (error) {
            console.error(error);
            setErrors(["Une erreur s'est produite lors de la validation"]);
            setOpenErrorDialog(true);
        }
    };

    const truncateLabel = (label) => {
        return label.length > 20 ? label.substring(0, 20) + '...' : label;
    };

    useEffect(() => {
        fetchTask()
    }, [dispatch, taskId, username]);
 

    return (
        <div className={classes.root}>
            <div style={{display: 'flex'}}>
            <div className={classes.mainContent}>
                <TaskInformation taskId={taskId}
                                 onClaimStatusChange={setIsTaskClaimed}
                />
                <Paper className={classes.paper}>
                    <div className={classes.leftSection}>
                        <div>
                                <label className={classes.inputLabel}>Eligibilité au règlement</label>
                                <select className={classes.inputContainer} name="decision"
                                        onChange={(e) => handleDecisionChange(e)} disabled={isTaskClaimed}  > 
                                <option className={classes.optionText} value="true" >Éligible au reglement</option>
                                <option className={classes.optionText} value="false">Non Éligible au reglement</option>
                            </select>
                        </div>
                        
                    {!decision && (
                        <><div>
                                    <label className={classes.inputLabel}>Motif non éligibilitér</label>
                                    <select className={classes.inputContainer} name="motif"
                                        onChange={handleMotifChange} disabled={isTaskClaimed}>
                                        <option className={classes.optionText} value="">Selection Motif</option>
                                        {motifs.map((motifOption) => (
                                            <option 
                                                key={motifOption.value}
                                                className={classes.optionText} 
                                                value={motifOption.value}
                                            >
                                                {motifOption.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {motif && motif !== "AVIS_EXPERT_DEFAVORABLE" && (
                                    <div>
                                        <label className={classes.inputLabel}>Sous motif non éligibilité</label>
                                        <Autocomplete
                                            multiple
                                            id="sub-motifs"
                                            options={subMotifsOptions[motif] || []}
                                            value={subMotifs}
                                            onChange={handleSubMotifsChange}
                                            disabled={isTaskClaimed}
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                            renderOption={(props, option, { selected }) => (
                                                <Tooltip 
                                                    title={option.label}
                                                    placement="right"
                                                    classes={{ tooltip: classes.tooltip }}
                                                >
                                                    <li {...props} className={`${props.className} ${classes.optionItem}`}>
                                                        {option.label}
                                                    </li>
                                                </Tooltip>
                                            )}
                                            renderTags={(tagValue, getTagProps) => {
                                                const visibleTag = tagValue[0];
                                                const hiddenTags = tagValue.slice(1);
                                                return (
                                                    <>
                                                        {visibleTag && (
                                                            <Tooltip 
                                                                title={visibleTag.label}
                                                                placement="top"
                                                                classes={{ tooltip: classes.tooltip }}
                                                            >
                                                                <span
                                                                    {...getTagProps({ index: 0 })}
                                                                    className={classes.autocompleteTag}
                                                                >
                                                                    {truncateLabel(visibleTag.label)}
                                                                </span>
                                                            </Tooltip>
                                                        )}
                                                        {hiddenTags.length > 0 && (
                                                            <Tooltip 
                                                                title={hiddenTags.map((tag) => tag.label).join(", ")}
                                                                placement="top"
                                                                classes={{ tooltip: classes.tooltip }}
                                                            >
                                                                <span
                                                                    className={classes.autocompleteTag}
                                                                >
                                                                    ... ({hiddenTags.length})
                                                                </span>
                                                            </Tooltip>
                                                        )}
                                                    </>
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    className={classes.inputContainer}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            )}
                                            sx={{
                                                fontFamily: "Poppins, sans-serif",
                                                "& .MuiOutlinedInput-root": {
                                                    p: 1,
                                                    height: "fit-content",
                                                    backgroundColor: "rgba(243, 246, 249, 1)",
                                                    fontSize: "0.75rem",
                                                    display: "flex",
                                                    fontFamily: "Poppins",
                                                    border: "none",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    "& fieldset": {
                                                        border: "none",
                                                    },
                                                },
                                                "& .MuiAutocomplete-popupIndicator": {
                                                    display: "none",
                                                },
                                                "& .MuiAutocomplete-tag": {
                                                    bgcolor: "rgba(240, 243, 199, 1)",
                                                    color: "rgba(60, 101, 86, 1)",
                                                    fontSize: "0.75rem",
                                                    padding: "2px 6px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    margin: "2px",
                                                },
                                                "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                                                    color: "rgba(60, 101, 86, 1)",
                                                    "&:hover": {
                                                        color: "rgba(60, 101, 86, 1)",
                                                    },
                                                },
                                            }}
                                        />
                                    </div>
                                )}
                        </>)
                    }   

                    </div>
                    <div className={classes.rightSection}>
                        <label className={classes.inputLabel}>Commentaire</label>
                        <br />
                        <textarea
                            disabled={isTaskClaimed}
                            className={classes.inputTextArea}
                            onChange={(e) => setComment(e.target.value)}
                            style={{
                                background: "rgba(243, 246, 249, 1)",
                                width: "519px",
                                height: 352,
                                borderRadius: "4px",
                                border: "none",
                                outline: "none",
                                padding: "40px",
                            }}
                        ></textarea>
                    </div>
                </Paper>
            </div>
            <PreviewButton claimData={infoSinistre}  />
        </div>
            <ValidationButton
                //taskId={taskId} 
                handleValidation={() =>isTaskClaimed? null : ValidationAction()} />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
        </div>
    );
};

export default MakeIneligible;